import { ConfirmDestructiveDialog } from '@/shared/components/ConfirmDestructiveDialog';

import { isLlmProfileError } from '../errors';

/**
 * Confirms removing one profile.
 *
 * `LLM_PROFILE_IN_USE` and the default-for-model refusal (spec 084 FR-015a)
 * are recoverable refusals the person needs to read, so a failed delete keeps
 * this dialog open with the mapped message, the same way
 * `LlmProfileFormSheet` keeps a failed save open with its refusal visible.
 *
 * Says what the delete does not take (spec 258 FR-005), as the workflow and
 * workspace delete dialogs do: the usage rows keep the profile's name.
 */
export function LlmProfileDeleteDialog({
  name,
  open,
  isPending,
  error,
  onConfirm,
  onCancel,
}: {
  name: string;
  open: boolean;
  isPending: boolean;
  error: unknown;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const serverError = isLlmProfileError(error) ? error : undefined;
  const message =
    serverError?.message ??
    (error ? 'The request failed. Please try again.' : null);

  return (
    <ConfirmDestructiveDialog
      open={open}
      title={<>Delete &ldquo;{name}&rdquo;?</>}
      confirmLabel="Delete profile"
      isPending={isPending}
      error={message}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      This removes &ldquo;{name}&rdquo; from this workspace. Any workflow step
      still referencing it must be repointed first. Its usage and spend stay on
      the AI usage pages under its name.
    </ConfirmDestructiveDialog>
  );
}
